import React, { useContext } from "react";
import { Link } from "react-router-dom";
import './WebButton.css'
import { useAppContext } from "../Context/AppContext";

const buildUrl = (base, path) => {
    const cleanBase = base.replace(/\/+$/, "");
    const cleanPath = path.replace(/^\/+/, "");
    return `${cleanBase}/${cleanPath}`;
};

const ViewMoreButtonDesktop = (props) => {
    const { BASE_PATH } = useContext(useAppContext);
    const { redirect } = props;

    if (!redirect) return null;

    return (
        <Link 
            className="webbutton d-none d-lg-block" 
            to={buildUrl(BASE_PATH, redirect)}
        >
            View More
        </Link>
    );
};

export const ViewMoreButtonMobile = (props) => {
    const { BASE_PATH } = useContext(useAppContext);
    const { redirect } = props;

    if (!redirect) return null;

    return (
        <Link 
            className="webbutton2 d-lg-none d-block" 
            to={buildUrl(BASE_PATH, redirect)}
        >
            View More
        </Link>
    );
};

export default ViewMoreButtonDesktop;